export default __webpack_public_path__ + "static/media/Inter-Light.3ee890bd.woff";